import { Badge } from '@chakra-ui/react'
import { useSlaTimer } from '@/hooks/useSlaTimer'

export function TimerCell({ requestedAt }: { requestedAt: string }) {
  const { remainingText, isCritical, isExpired } = useSlaTimer(requestedAt)


  if (isExpired) return <Badge colorScheme="red">0:00</Badge>
  if (isCritical) return <Badge colorScheme="orange">{remainingText}</Badge>
  return <Badge colorScheme="gray">{remainingText}</Badge>
}